import { render, staticRenderFns } from "./DeckList.vue?vue&type=template&id=07aaa706&"
import script from "./DeckList.vue?vue&type=script&lang=js&"
export * from "./DeckList.vue?vue&type=script&lang=js&"
import style0 from "./DeckList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports